import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IBidResponse, BidResponse } from '../../models/IBidResponse';
import { IBid, Bid } from '../../models/IBid';
import { S1DataService } from '../../services/s1data.service';
import { FezaDataService } from '../../services/fezadata.service';
import { RouteDataService } from '../../services/routedata.services';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../services/auth-service.service';
import { Utils } from '../../Utils';

@Component({
    selector: 'app-subsample',
    templateUrl: './subsample.component.html',
    styleUrls: ['./subsample.component.css']
})
export class SubsampleComponent implements OnInit {
    response: IBidResponse;
    request: IBid;
    subsampleId: number;
    message: string;

    constructor(private router: Router,
        private route: ActivatedRoute,
        private s1dataservice: S1DataService,
        private fezaService: FezaDataService,
        private routeDataService: RouteDataService,
        private auth: AuthService
    ) {
        this.route.queryParams.subscribe(params => {
            this.subsampleId = params['sid'];

            if (this.subsampleId > 0) {
                this.message = `Checking feasiblity for Subsample ${this.subsampleId}...`;
                var bidId = this.s1dataservice.getBidNameFromSubsample(this.subsampleId);
                this.fezaService.GetResponse(bidId, "USD").subscribe(bid => {
                    this.loadWithOldBid(bid.request);
                }, error => {
                    this.loadWithOldBid(new Bid());
                });
            }
        });
    }

    ngOnInit() {
    }

    loadWithOldBid(oldBid: IBid) {
        this.s1dataservice.getBidFromSubsampleId(this.subsampleId, this.auth.Email, oldBid).subscribe(bid => {
            this.fezaService.setDefaultFactorsForSample(bid.feasibilities[0]).subscribe(sample => {
              bid.feasibilities[0] = sample;
              this.fezaService.ProcessfeasibilityRequest(bid, Utils.generateUUID()).subscribe(resp => {
                    resp.request = bid;
                    this.routeDataService.routedBidRequestValue = Observable.of(bid);
                    this.routeDataService.routedBidResponseValue = Observable.of(resp);
                    this.router.navigateByUrl(`/s1response?sid=${this.subsampleId}&bidId=${bid.bidId}`);
                },
                    err => {
                      if (err.error && err.error.errors)
                        this.message = `Error response from feza API!<br/> ${Utils.getErrorDetailsString(err)} bidId:${bid.bidId}`;
                        else
                            this.message = `Error response from feza API! bidId:${bid.bidId}`;
                    });
            });
        },
            err => {
                console.log("s1 error:" + err);
                this.message = "Failed to get fesa data from S1! " + err;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/subsample/subsample.component.ts